import { createContext, useContext, useState, useCallback, useEffect, useMemo } from "react";
import { translations, LANGUAGES } from "@/i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("chenia_lang") || "fr");

  useEffect(() => {
    localStorage.setItem("chenia_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (key, vars) => {
      const dict = translations[lang] || translations.fr;
      let str = dict[key] ?? translations.fr[key] ?? key;
      if (vars) Object.entries(vars).forEach(([k, v]) => { str = str.replace(`{${k}}`, v); });
      return str;
    },
    [lang]
  );

  // localized value from an i18n object {fr,en,de,it}, with fallback
  const tv = useCallback(
    (obj) => {
      if (!obj) return "";
      if (typeof obj === "string") return obj;
      return obj[lang] || obj.en || obj.fr || Object.values(obj)[0] || "";
    },
    [lang]
  );

  const value = useMemo(() => ({ lang, setLang, t, tv, languages: LANGUAGES }), [lang, t, tv]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
